export class CovenantLogin {

    email: string;
    password: string;
}